var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDoubleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/chevron-double-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3741 6.29289C27.7646 6.68342 27.7646 7.31658 27.3741 7.70711L17.3741 17.7071C16.9836 18.0976 16.3504 18.0976 15.9599 17.7071L5.95989 7.70711C5.56936 7.31658 5.56936 6.68342 5.95989 6.29289C6.35041 5.90237 6.98357 5.90237 7.3741 6.29289L16.667 15.5858L25.9599 6.29289C26.3504 5.90237 26.9836 5.90237 27.3741 6.29289ZM27.3741 14.2929C27.7646 14.6834 27.7646 15.3166 27.3741 15.7071L17.3741 25.7071C16.9836 26.0976 16.3504 26.0976 15.9599 25.7071L5.95989 15.7071C5.56936 15.3166 5.56936 14.6834 5.95989 14.2929C6.35041 13.9024 6.98357 13.9024 7.3741 14.2929L16.667 23.5858L25.9599 14.2929C26.3504 13.9024 26.9836 13.9024 27.3741 14.2929Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleDown);
export default __webpack_public_path__ + "static/media/chevron-double-down.1e1871fc49073588fa1f9e7a55e857aa.svg";
export { ForwardRef as ReactComponent };